import { Component } from '@angular/core';
import { HubSpotSandboxService } from '../../services/hubspot-sandbox.service';

@Component({
    selector: 'app-hubspot-sandbox-toggle',
    templateUrl: './hubspot-sandbox-toggle.component.html'
})
export class HubSpotSandboxToggleComponent {
    constructor(public sandbox: HubSpotSandboxService) { }
}



// WEBPACK FOOTER //
// ./src/app/developer/components/hubspot-sandbox-toggle/hubspot-sandbox-toggle.component.ts